import { theme } from "shared/lib/styles";

import type { Props as AdSlotProps } from "scmp-app/components/advertisement/ad-slots/ad-slot";
import { TargetingPaidType } from "scmp-app/components/advertisement/ad-slots/types";

export const getTopicAdsConfigs = (
  topicId: string,
  adZone = "default",
  isShowSpecificWidget: boolean = false,
) => {
  const defaultAdSlotProps: Partial<AdSlotProps> = {
    targeting: {
      paid: TargetingPaidType.NotArticle,
      sctid: topicId,
    },
    withBackground: true,
    withLabel: true,
    withSticky: true,
    zone: adZone,
  };

  const configs: Array<[AdSlotProps, AdSlotProps, AdSlotProps]> = [
    [
      // Ads1
      {
        ...defaultAdSlotProps,
        adUnit: "d_lrec1",
        breakpoint: theme.breakpoints.up("desktop"),
        sizes: [[300, 250]],
      },
      {
        ...defaultAdSlotProps,
        adUnit: "m_lrec1",
        breakpoint: theme.breakpoints.only("tablet"),
        sizes: [[300, 250]],
      },
      {
        ...defaultAdSlotProps,
        adUnit: "m_banner1",
        breakpoint: theme.breakpoints.only("mobile"),
        sizes: [[300, 250]],
      },
    ],
    // Ads2
    [
      {
        ...defaultAdSlotProps,
        adUnit: "d_lrec3",
        breakpoint: theme.breakpoints.up("desktop"),
        sizes: isShowSpecificWidget
          ? [[300, 250]]
          : [
              [300, 250],
              [300, 600],
            ],
      },
      {
        ...defaultAdSlotProps,
        adUnit: "m_lrec3",
        breakpoint: theme.breakpoints.only("tablet"),
        sizes: isShowSpecificWidget
          ? [[300, 250]]
          : [
              [300, 250],
              [320, 480],
            ],
      },
      {
        ...defaultAdSlotProps,
        adUnit: "m_lrec1",
        breakpoint: theme.breakpoints.only("mobile"),
        sizes: [
          [300, 250],
          [320, 480],
        ],
      },
    ],
    // Ads3
    [
      {
        ...defaultAdSlotProps,
        adUnit: "d_lrec3a",
        breakpoint: theme.breakpoints.up("desktop"),
        sizes: isShowSpecificWidget
          ? [
              [300, 250],
              [300, 600],
            ]
          : [[300, 250]],
      },
      {
        ...defaultAdSlotProps,
        adUnit: "m_lrec3a",
        breakpoint: theme.breakpoints.only("tablet"),
        sizes: isShowSpecificWidget
          ? [
              [300, 250],
              [320, 480],
            ]
          : [[300, 250]],
      },
      {
        ...defaultAdSlotProps,
        adUnit: "m_lrec3",
        breakpoint: theme.breakpoints.only("mobile"),
        sizes: [[300, 250]],
      },
    ],
    // Ads4
    [
      {
        ...defaultAdSlotProps,
        adUnit: "d_lrec2",
        breakpoint: theme.breakpoints.up("desktop"),
        sizes: [[300, 250]],
      },
      {
        ...defaultAdSlotProps,
        adUnit: "m_lrec2",
        breakpoint: theme.breakpoints.only("tablet"),
        sizes: [[300, 250]],
      },
      {
        ...defaultAdSlotProps,
        adUnit: "m_lrec2",
        breakpoint: theme.breakpoints.only("mobile"),
        sizes: [
          [300, 250],
          [320, 480],
        ],
      },
    ],
  ];

  return configs;
};
